import React from "react";
import "./SYSADMIN/Style/Links.css";

const Links: React.FC = () => {
  const handleClick = (type: string) => {
    console.log(`${type} clicked`);

    switch (type) {
        case "elearn-live":
            window.location.href = "https://elearn.elearnoncloud.com?C=DLR_KE_AU";
            break;
        case "elearn-staging":
            window.location.href = "https://staging.elearn.elearnoncloud.com?C=DLR_KE_AU";
            break;
        case "sysadmin-live":
            window.location.href = "https://sysadmin.elearnoncloud.com/";
            break;
        case "sysadmin-staging":
            window.location.href = "https://staging.sysadmin.elearnoncloud.com/";
            break;
    }
  };

  return (
    <div id="divLinks" className="links-page-bg">
      <div className="link-section">
        <h2 >eLearn</h2>

        <div className="link-row">
          <button
            className="link_btn_Live"
            onClick={() => handleClick("elearn-live")}
          />

          <button
            className="link_btn_Staging"
            onClick={() => handleClick("elearn-staging")}
          />
        </div>
      </div>

      <div className="link-section">
        <h2 >SysAdmin</h2>

        <div className="link-row">
          <button
            className="link_btn_Live"
            onClick={() => handleClick("sysadmin-live")}
          />

          <button
            className="link_btn_Staging"
            onClick={() => handleClick("sysadmin-staging")}
          />
        </div>
      </div>
    </div>
  );
};

export default Links;
